<template>
  <div class="cognito"></div>
</template>
<script>
import { mapGetters } from "vuex";
import eventBus from "../eventBus";
export default {
  name: "Cognito",
  data: function() {
    return {
      payload: ""
    };
  },
  mounted() {
    eventBus.$on("TOKEN_DISPLAY_USERINFO", params => {
      this.getUserInfo(params);
    });
  },
  computed: {
    ...mapGetters(["cognito/getIdToken"])
  },
  methods: {
    getUserInfo: function() {
      let IdToken = this.$store.getters["cognito/getIdToken"]();
      try {
        if (!IdToken) throw 401;
        fetch(".netlify/functions/userinfo", {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            // prettier-ignore
            "Authorization": "Bearer " + IdToken
          }
        })
          .then(response => {
            if (!response.ok) throw response.status;
            else return response.json();
          })
          .then(json => {
            let resp = "";
            json.forEach(function(item) {
              resp = resp + "<li>" + item.Name + " : " + item.Value + "</li>";
            });
            eventBus.$emit("SLIDE_UPDATED", [
              {
                id: 0,
                list: {
                  caption: "User Info",
                  html: (resp = "<ul>" + resp + "</ul>")
                }
              }
            ]);
          })
          .catch(err => {
            eventBus.$emit("SLIDE_UPDATED", [
              {
                id: 0,
                quote: {
                  icon: "fa fa-exclamation-triangle",
                  caption: "Error",
                  text: JSON.stringify(err, Object.getOwnPropertyNames(err))
                }
              }
            ]);
          });
      } catch (err) {
        eventBus.$emit("SLIDE_UPDATED", [
          {
            id: 0,
            quote: {
              icon: "fa fa-exclamation-triangle",
              caption: "Sorry",
              text: "user information is only available after sign in"
            }
          }
        ]);
      }
    }
  }
};
</script>
<style scoped>
html,
body {
  height: 100%;
}
@import url(https://fonts.googleapis.com/css?family=Roboto:400);
@import url(https://use.fontawesome.com/releases/v5.10.2/css/all.css);
*,
*:before,
*:after {
  box-sizing: border-box;
}
.cognito {
  padding: 0;
  margin: 0;
}
</style>
